import { useContext } from "react";

import moment, { unitOfTime } from "moment-timezone";

import TimeZoneContext from "context/timeZone/timeZoneContext";

import { DateType } from "../types";

export const useDateTime = () => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const currentLocale = moment.locale();

    const formattedDate = (
        date: DateType,
        format: string = "L LTS",
        locale: string = currentLocale
    ) => {
        if (date === null || date === "-") {
            return "-";
        }

        return moment
            .utc(date)
            .tz(currentTimeZone)
            .locale(locale)
            .format(format);
    };

    const startOfTime = (period: string) =>
        moment().startOf(period as unitOfTime.StartOf);

    return { formattedDate, startOfTime };
};
